/**
 * @generated SignedSource<<51faf9c56c4cf77b62ca8c476770c34a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs, Result } from "relay-runtime";
export type useFavouriteContentFragment_content$data = Result<{
  readonly id: string | null;
  readonly metadata: {
    readonly currentuser: {
      readonly favourited: {
        readonly isFavourite: boolean | null;
      } | null;
    } | null;
  };
  readonly operations: ReadonlyArray<{
    readonly operation: string | null;
    readonly targetType: string | null;
  } | null> | null;
  readonly type: string | null;
  readonly " $fragmentType": "useFavouriteContentFragment_content";
}, unknown>;
export type useFavouriteContentFragment_content$key = {
  readonly " $data"?: useFavouriteContentFragment_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"useFavouriteContentFragment_content">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "catchTo": "RESULT"
  },
  "name": "useFavouriteContentFragment_content",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "concreteType": "ContentMetadata",
      "kind": "LinkedField",
      "name": "metadata",
      "plural": false,
      "selections": [
        {
          "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
          "kind": "LinkedField",
          "name": "currentuser",
          "plural": false,
          "selections": [
            {
              "concreteType": "FavouritedSummary",
              "kind": "LinkedField",
              "name": "favourited",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "isFavourite"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "concreteType": "OperationCheckResult",
      "kind": "LinkedField",
      "name": "operations",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "operation"
        },
        {
          "kind": "ScalarField",
          "name": "targetType"
        }
      ]
    }
  ],
  "type": "Content"
};

(node as any).hash = "9eb4bba18a80a6c1d0af5e71192cdef7";

export default node;
